// Values are named after the clients themselves (client.web.tenant ->
// tenant-web) and must stay in step with BookingSource in
// server.service.property. The member names are historical; the values are the
// contract.
export enum ReservationSource {
  BN_ADMIN = 'admin-web',
  BN_APP = 'tenant-app',
  BN_WEBSITE = 'tenant-web',
  CX = 'cx',
  OFFLINE_SALES = 'offline-sales',
  ACQUISITION_TEAM = 'acquisition-team',
  // Two distinct answers, both valid. PARTNERS is what this tool records when
  // an admin attributes a reservation to the partners team -- a team name, like
  // CX and OFFLINE_SALES. PARTNER_WEB is a partner booking themselves in the
  // partner portal -- a client name, like BN_APP and BN_WEBSITE.
  //
  // PARTNERS used to carry 'partner-web', so reservations this tool created
  // before the split still hold that value. They were deliberately not
  // migrated, which is why PARTNER_WEB has to stay listed and labelled: the
  // edit modal renders whatever a reservation already carries.
  PARTNERS = 'partners',
  PARTNER_WEB = 'partner-web',
  CHANNEL_MANAGER = 'channel-manager'
}
